import React, {Fragment, useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {moreFromPocketClick, moreFromPocketScroll} from '../../ctas';
import TrackedLink from '../TrackedLink/Element';
import analyticsTriggers from '../../analytics/triggers';
import VisibilitySensor from '../../../Components/VisibilitySensor';
import {fireGtagEvent, getEventLabel} from '../../helpers/gtag-helpers';
import './styles.scss';
import {getSyndicatedArticleRecs} from '../../api';

const MODULE_NAME = "syndicated_article";

const SuggestedArticle = ({article, item, index, model, recId, pageLoadId, synArticleId}) => {
  const path = `/explore/item/${article.slug}`;
  const ArticleLink = TrackedLink(({...moreFromPocketClick, index}));
  const {name, category, nonInteraction, label} = moreFromPocketScroll;

  const handleClick = () => {
    analyticsTriggers.recitClick(
        model,
        recId,
        pageLoadId,
        synArticleId,
        MODULE_NAME,
        index,
        item.item_id
    )
  }

  return (
      <VisibilitySensor onVisible={() => {
        fireGtagEvent(name, getEventLabel(label, index), category, nonInteraction);
        analyticsTriggers.recitImpression(model, recId, pageLoadId, synArticleId, MODULE_NAME, index, item.item_id);
      }}>
        <li className="related-article">
          <ArticleLink href={path} onClick={handleClick}>
            <img className="thumbnail" src={article.topImageUrl}/>
          </ArticleLink>
          <div className="details">
            <ArticleLink className="publisher-link" href={path} onClick={handleClick}>
              {article.publisher.logoWideBwUrl
                  ? <img className="publisher-logo" src={article.publisher.logoWideBwUrl}/>
                  : <span className="publisher-logo--text">{article.publisher.name}</span>
              }
            </ArticleLink>
            <ArticleLink href={path} onClick={handleClick} className="title">{article.title}</ArticleLink>
          </div>
        </li>
      </VisibilitySensor>
  )
};

const MoreFromPocket = ({synArticleId, resolvedId, pageLoadId, sectionTitle, initialResponse}) => {
  const [articles, updateArticles] = useState(initialResponse.recommendations);
  const [model, updateModel] = useState(initialResponse.model);
  const [recId, updateRecId] = useState(initialResponse.rec_id);

  if (resolvedId) {
    useEffect(() => {
      getSyndicatedArticleRecs(
          resolvedId,
          (response) => {
            const {recommendations, model, rec_id} = response;

            updateModel(model);
            updateArticles(recommendations);
            updateRecId(rec_id);
          },
          (error) => {
            // TODO: meet w FE team to talk about error handling in our apps here
            // https://getpocket.atlassian.net/wiki/spaces/FRONT/pages/900858150/Projects
          },
      )
    }, []);
  }

  if (!articles.length) return null;

  return (
      <Fragment>
        <div className="more-from-pocket">
          <h3 className="section-title">{sectionTitle}</h3>
          <ul className="list">
            {articles.map((a, index) => (
                <SuggestedArticle
                    key={a.syndicated_article.slug}
                    article={a.syndicated_article}
                    item={a.item}
                    index={index}
                    synArticleId={synArticleId}
                    model={model}
                    recId={recId}
                    pageLoadId={pageLoadId}
                />
            ))}
          </ul>
        </div>
      </Fragment>
  )
}

MoreFromPocket.propTypes = {
  synArticleId: PropTypes.string.required,
  resolvedId: PropTypes.string.required,
  pageLoadId: PropTypes.string.required,
  sectionTitle: PropTypes.string,
  initialResponse: PropTypes.shape({}),
}

MoreFromPocket.defaultProps = {
  sectionTitle: "More Stories from Pocket",
  initialResponse: {recommendations: []},
}

export default MoreFromPocket;
